module.exports = __webpack_public_path__ + "img/cho-nam-joo.447901d9.png";